module.exports = __webpack_public_path__ + "static/img/team_honor_order_8.b39fcdeb.png";